__turbopack_context__.v({
  "flexContainer": "FeaturedFieldMatches-module__Z9Ed6q__flexContainer",
});
